
import React, {Component} from 'react';
import Intro from '../../component/Intro/Intro'
import MinimalCoverVideo from '../../component/HomePageInfo/MinimalCoverVideo/MinimalCoverVideo'
import HomePageInfo from '../../component/HomePageInfo/HomePageInfo'
class HomePage extends Component{
    render(){
        let randNum = Math.floor(Math.random() * Math.floor(3));
        return(
            <div>
                <Intro />
                <MinimalCoverVideo randNum={randNum}/>
                
                <HomePageInfo />
                <MinimalCoverVideo randNum={randNum}/>
                
            </div>

        )
    }
}

export default HomePage;